var map = {
	"./BG.svg": "0c7f",
	"./DeliverDrug.svg": "e763",
	"./DeliverDrug2.svg": "aaae",
	"./Doc": "d1dc",
	"./Doc.vue": "d1dc",
	"./Doctor_payment.svg": "29ea",
	"./FMR-active.svg": "b765",
	"./FMR.svg": "1244",
	"./Frame 1000003127.svg": "77ab",
	"./Group 1504775666.svg": "e84c",
	"./Group 1504775755.svg": "4937",
	"./Group 1504775756.svg": "1702",
	"./Group 1504775757.svg": "e38e",
	"./Group 1504775915.svg": "1bbb",
	"./Group 1504775918.svg": "81ac",
	"./Group 427323244.png": "a33a",
	"./Group 427323471.png": "b088",
	"./Group 427323896.png": "b483",
	"./IClaim-active.svg": "1a20",
	"./IClaim.svg": "398a",
	"./InformationNews/message.svg": "72f3",
	"./InformationNews/message1.svg": "667f",
	"./InformationNews/message2.svg": "3666",
	"./InformationNews/message_active.svg": "c806",
	"./InformationNews/message_active1.svg": "5a05",
	"./InformationNews/news.svg": "95cb",
	"./InformationNews/news1.svg": "c85e",
	"./InformationNews/news_active1.svg": "edbd",
	"./InformationNews/vector.svg": "28b2",
	"./InformationNews/vector_active.svg": "14d1",
	"./InformationNews/web.svg": "1ae8",
	"./InformationNews/web1.svg": "5214f",
	"./InformationNews/web2.svg": "dec1",
	"./InformationNews/web_active.svg": "dfe6",
	"./InformationNews/web_active1.svg": "7bf5",
	"./Logo_Navbar_Health_Rider_2.png": "bd60",
	"./Succes_B.png": "cc95",
	"./Succes_G.png": "163d",
	"./Succes_Gw.png": "f0cf",
	"./Telepharma/1.1.svg": "7188",
	"./Telepharma/1.2.svg": "c017",
	"./Telepharma/2.1.svg": "7ee2",
	"./Telepharma/2.2.svg": "40df",
	"./Telepharma/3.1.svg": "8bac",
	"./Telepharma/3.2.svg": "8269",
	"./Telepharma/4.1.svg": "904f",
	"./Telepharma/4.2.svg": "fc37",
	"./Telepharma/5.1.svg": "4bdb",
	"./Telepharma/5.2.svg": "ec29d",
	"./Telepharma/BG.svg": "4220",
	"./Telepharma/Bill.png": "50ea",
	"./Telepharma/Cardboard_pile_of_boxes_art_illustration 1.svg": "6c95",
	"./Telepharma/Delivery-disable.svg": "c023",
	"./Telepharma/Delivery.svg": "0446",
	"./Telepharma/Delivery2.svg": "546c",
	"./Telepharma/Distant.svg": "1c45",
	"./Telepharma/Doctor.svg": "69b4",
	"./Telepharma/Find a driver (1).svg": "4b77",
	"./Telepharma/Find a driver.svg": "f03f",
	"./Telepharma/Frame 427325370.svg": "ab42",
	"./Telepharma/Group 1000000928.svg": "15ee",
	"./Telepharma/Group 1000000931.svg": "21f5",
	"./Telepharma/Group 427325155.svg": "adf3",
	"./Telepharma/Group.svg": "17d6",
	"./Telepharma/Map.svg": "cdbb",
	"./Telepharma/Sending (1).svg": "014f",
	"./Telepharma/Sending.svg": "a4e6",
	"./Telepharma/Status.svg": "93c5",
	"./Telepharma/Track.svg": "30e9",
	"./Telepharma/Vector.svg": "dd34",
	"./Telepharma/all-dark.svg": "faa0",
	"./Telepharma/all-light.svg": "f613",
	"./Telepharma/barcode.svg": "0fef",
	"./Telepharma/bike 1.svg": "c13d",
	"./Telepharma/bike 2.svg": "158a",
	"./Telepharma/bike 3.svg": "cea4",
	"./Telepharma/box 1.svg": "2d08",
	"./Telepharma/cancel.svg": "0004",
	"./Telepharma/delivery-courier 2.svg": "b499",
	"./Telepharma/driver (1).svg": "9b56",
	"./Telepharma/driver.svg": "f9d8",
	"./Telepharma/eye-outline.svg": "0fcd",
	"./Telepharma/finish (1).svg": "6e62",
	"./Telepharma/finish.svg": "461a",
	"./Telepharma/hospital-buildings.svg": "5ea8",
	"./Telepharma/iconTelephama.svg": "543d",
	"./Telepharma/login_fail.svg": "faac",
	"./Telepharma/pickup point (1).svg": "a2d0",
	"./Telepharma/pickup point.svg": "f0fb",
	"./Telepharma/prepare medicine.svg": "bcab",
	"./Telepharma/receive parcel (1).svg": "9a90",
	"./Telepharma/receive parcel.svg": "4c7a",
	"./Telepharma/register.svg": "dfe0",
	"./Telepharma/send parcel (1).svg": "da73",
	"./Telepharma/send parcel.svg": "170e",
	"./Telepharma/success.svg": "3edb",
	"./Telepharma/transport.svg": "d8f5",
	"./Telepharma/video-disabled.svg": "3ba8",
	"./Telepharma/video-outline.svg": "e940",
	"./Trash.png": "8eae",
	"./Trash_P.png": "90f0",
	"./Trash_w.png": "10a4",
	"./Vector.png": "07c6",
	"./alert-circle - Muti Ncds.png": "7f1f",
	"./all-agree.png": "06ed",
	"./approved.svg": "46d5",
	"./bg-login.svg": "0290",
	"./browser.png": "3e27",
	"./building-active.svg": "ed32",
	"./building.svg": "a5f3",
	"./calendar-add-new.png": "0200",
	"./calendar-add.png": "57b9",
	"./calendars-active.svg": "973f",
	"./calendars.svg": "e24f",
	"./calling copy.svg": "3ae7",
	"./calling.svg": "e11f",
	"./check-circle 1.png": "ec6c",
	"./check-circle 2.png": "5b4f",
	"./check-circle.png": "53d8",
	"./check-up.png": "6423",
	"./contact_active.png": "a6f6",
	"./contact_inactive.png": "926d",
	"./dashboard-active.svg": "2ea7",
	"./dashboard-admin-active.svg": "f485",
	"./dashboard-admin.svg": "cb49",
	"./dashboard-icon-active.svg": "ef8b",
	"./dashboard-icon.svg": "0376",
	"./detail.svg": "060a",
	"./doctor-active.svg": "ef41",
	"./doctor.svg": "ff30",
	"./document.svg": "c47c",
	"./dr-consultation.gif": "a20b",
	"./drug-active.svg": "3d75",
	"./drug.svg": "edf9",
	"./file_medical.png": "ade7",
	"./getdrug1.png": "0f11",
	"./getdrug2.png": "1a4b",
	"./healthCheck-active.svg": "0bb8",
	"./healthCheck.svg": "7be4",
	"./home-icon-active.svg": "c7ad",
	"./home-icon.svg": "d853",
	"./icon-video-w.png": "80a1",
	"./icon_NCDs_A01_af.png": "92ff",
	"./icon_NCDs_A01_bf.png": "5174",
	"./icon_NCDs_A02_af.png": "9bbe",
	"./icon_NCDs_A02_bf.png": "098d",
	"./icon_NCDs_A03_af.png": "5843",
	"./icon_NCDs_A03_bf.png": "d696",
	"./icon_NCDs_A04_af.png": "f942",
	"./icon_NCDs_A04_bf.png": "fde5",
	"./icon_NCDs_A05_af.png": "964a",
	"./icon_NCDs_A05_bf.png": "7dab",
	"./icon_NCDs_A06_af.png": "81f2",
	"./icon_NCDs_A06_bf.png": "7a83",
	"./id.png": "daff",
	"./logo Dowell.svg": "cb04",
	"./logo Telemed.svg": "443d",
	"./logo.svg": "d191",
	"./main-active.svg": "b3f0",
	"./main.svg": "f27a",
	"./medcert/all-dark.svg": "676c",
	"./medcert/all-light.svg": "f224",
	"./medcert/all.svg": "21c3",
	"./medcert/calendar.svg": "9195",
	"./medcert/cancle.svg": "7469",
	"./medcert/close-outline.svg": "16b7a",
	"./medcert/doctor.svg": "935b",
	"./medcert/down.png": "6b73",
	"./medcert/down.svg": "3986",
	"./medcert/in progress.svg": "c120",
	"./medcert/pencil-line.svg": "a21b",
	"./medcert/search.png": "5b5d",
	"./medcert/search.svg": "7476",
	"./medcert/sending.svg": "2e54",
	"./medcert/success.svg": "c9f7",
	"./medcert/sucess.svg": "9ba3",
	"./medcert/transport.svg": "aa70",
	"./medical-record.svg": "8902",
	"./mic-off.png": "7623",
	"./news 1.svg": "88ac",
	"./organization-active.svg": "8ba7",
	"./organization.svg": "a83f",
	"./patientlist.svg": "aeb3",
	"./patientlist2.svg": "dc0b",
	"./payment-active.svg": "e995",
	"./payment.svg": "2821",
	"./payment_p.png": "787d",
	"./payment_s.svg": "6c63",
	"./picture.png": "70d6",
	"./profile/edit-sign-icon.svg": "0e423",
	"./receiver.svg": "9eec",
	"./report-icon-active.svg": "19fe",
	"./report-icon.svg": "6cb2",
	"./sign.svg": "5381",
	"./telemed.svg": "929e",
	"./telepharma.svg": "1f95",
	"./vcsconflicting_93497.png": "02c0",
	"./vert 2.png": "03c8",
	"./vert.png": "c91a",
	"./vert_white1 2.png": "6488",
	"./vert_white1.png": "c3d6",
	"./video-af-Completed.png": "6f8c",
	"./video-bf-Completed.png": "c2ca",
	"./visit/Group 1000002996.svg": "96b1",
	"./visit/Group.svg": "55ef",
	"./visit/Vector 2.svg": "00f9",
	"./visit/clinic.svg": "a819",
	"./visit/factory.svg": "378c",
	"./visit/form-list.svg": "b187",
	"./visit/home.svg": "a4f6",
	"./visit/hospital-building.svg": "c46e",
	"./visit/image.svg": "5e08",
	"./visit/img-text.svg": "c290",
	"./visit/medical-symbol.svg": "7f16",
	"./visit/mosque.svg": "d147",
	"./visit/pharmacy.svg": "6b8b",
	"./visit/river.svg": "5cf0",
	"./visit/school.svg": "1dbf",
	"./visit/swimming-pool.svg": "bc06",
	"./visit/wat-phra-kaew.svg": "712c",
	"./wait-status.svg": "b2a9",
	"./weather_R.png": "e094",
	"./weather_Y.png": "3cb9",
	"./x.png": "d8f2",
	"./x_white.png": "9b00"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8873";